import { createContext } from 'react';

export const showHelpTextContext = createContext<[boolean, React.Dispatch<React.SetStateAction<boolean>>]>([
  false,
  () => {
    throw new Error('not in showHelpTextContext');
  },
]);
